// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1CsSM","left":"InfoRow_left__3fFbZ"};